module.exports = __webpack_public_path__ + "static/contact-form-image-ff28adde824659a605997b7a3b7ae59c.jpg";